import * as Yup from 'yup';
export const initialSiteAddressValues = {
    name: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    postalCode: '',
    ward: '',
    provinceId: '',
    area: '',
    areaClassification: '',
    areaSubClassification: '',
    municipality: '',
};
export const siteAddressSchema = Yup.object().shape({
    name: Yup.string(),
    addressLine1: Yup.string(),
    addressLine2: Yup.string(),
    addressLine3: Yup.string(),
    postalCode: Yup.string()
        .matches(/^\d{4}$/, 'Postal Code must be exactly 4 digits')
        .required('Postal Code is required'),
    ward: Yup.string(),
    provinceId: Yup.string(),
    area: Yup.string(),
    areaClassification: Yup.string(),
    areaSubClassification: Yup.string(),
});
//# sourceMappingURL=site-address.js.map